<template>
    <div class="retr__content">
        <div v-for="(el, idx) in retr.list" :key="`el-${idx}`" class="retr__rows-group">
            <div class="retr__row" :class="{ active: expandedIds.includes(idx) }">
                <table-row
                    bold
                    :element="el"
                    :name="el.contractor || el.name"
                    :value="el.valueSum"
                    :percent="el.percent"
                    :expandable="!!el.list?.length"
                    :is-active="expandedIds.includes(idx)"
                    @click.native="toggleExpandable(idx)"
                />

                <transition-slide>
                    <div v-if="expandedIds.includes(idx)">
                        <div class="retr__row-content">
                            <template v-if="el.list">
                                <table-row v-for="(val, idxx) in el.list"
                                    :key="`contractor-values-${idx}-${idxx}`"
                                    :element="el"
                                    class="retr__row-second"
                                    :name="val.name"
                                    :value="val.value"
                                    :reclamation-button="retr.reclamationButton"
                                    @reclamation-click="onReclamationClick(el, val)"
                                />
                            </template>
                            <template v-else>
                                <table-row
                                    class="retr__row-second"
                                    :name="val.name"
                                    :value="val.value"
                                />
                            </template>
                        </div>
                    </div>
                </transition-slide>
            </div>
        </div>
    </div>
</template>

<script>
import retrMixin from './retr.mixin.js'

export default {
    mixins: [retrMixin]
}
</script>
